const processAccessTokenResponse = (accessTokenResponse) => {
  if (
    accessTokenResponse.data.access_token !== "" &&
    accessTokenResponse.data.refresh_token !== ""
  ) {
    localStorage.setItem("accessToken", accessTokenResponse.data.access_token);
    localStorage.setItem(
      "refreshToken",
      accessTokenResponse.data.refresh_token
    );
    return true;
  }
  return false;
};

export { processAccessTokenResponse };
